import { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import CloseBtn from "../CloseBtn/CloseBtn";
import CloseIcon from "../../assets/img/icons/close.svg";
import { Tag, TagContainer } from "../Tag";

export default function Keywords({ keywords, setFieldValue, edit = false }) {
	// Initialize from incoming prop if it's an array, otherwise start with empty array
	const [keywordsState, setKeywords] = useState(Array.isArray(keywords) ? keywords : []);

	// Sync local state only when a concrete array is provided via props
	useEffect(() => {
		if (Array.isArray(keywords)) {
			setKeywords(keywords);
		}
	}, [keywords]);

	// Update Formik field value when keywords change, but use callback to prevent infinite loop
	const updateFormikField = useCallback((newKeywords) => {
		if (edit && setFieldValue) {
			setFieldValue("keywords", newKeywords);
		}
	}, [edit, setFieldValue]);

	const add = (e) => {
		if (e.key === "Enter") {
			e.preventDefault();
			const value = (e.target.value || "").trim();
			if (!value) return;
			const newKeywords = [...keywordsState, value];
			setKeywords(newKeywords);
			updateFormikField(newKeywords);
			e.target.value = "";
		}
	};

	const remove = (keyword, e) => {
		e.preventDefault();
		const index = keywordsState.indexOf(keyword);
		if (index > -1) {
			const newKeywords = [...keywordsState.slice(0, index), ...keywordsState.slice(index + 1, keywordsState.length)];
			setKeywords(newKeywords);
			updateFormikField(newKeywords);
		}
	};

	return (
		<>
			<label>Keywords</label>
			{edit && keywordsState && keywordsState.length < 2 ? (
				<input type="text" onKeyDown={add} placeholder="Press Enter to add keywords for this decision" defaultValue={""} />
			) : (
				""
			)}
			<TagContainer>
				{keywordsState &&
					keywordsState.map((keyword, id) => {
						return (
							<Tag key={id}>
								<>
									{keyword}
									{edit && <CloseBtn onClick={(e) => remove(keyword, e)} icon={CloseIcon} small />}
								</>
							</Tag>
						);
					})}
			</TagContainer>
		</>
	);
}

Keywords.propTypes = {
	keywords: PropTypes.array,
	setFieldValue: PropTypes.func,
	edit: PropTypes.bool,
};
